import { KeyEmpty, KeyBase, IIsDefined } from '@kpd/framework-ngx';

export class RoleKey extends KeyBase implements IIsDefined {
  static composeKeyByRouteParams(params: { name: string; application: string }): KeyBase {
    const name = decodeURIComponent(params.name);
    const app = decodeURIComponent(params.application);
    if (name === '0' && app === '0') {
      return new KeyEmpty();
    }
    return new RoleKey(name, app);
  }

  constructor(public name: string, public application: string) {
    super();
  }

  toString(): string {
    if (this.name === '0' && this.application === '0') {
      return '0'; // New entity
    }
    return `${this.name}:${this.application}`;
  }

  isDefined(): boolean {
    return !!this.name || !!this.application;
  }
}
